import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";


// code
const PmConversionMetricMaster = () => {
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [editFormData, setEditFormData] = useState({
    fg_category: "",
    roll: "",
    wieght_in_kg_for_rolls: "",
    pouches_per_kg: "",
    conversion_to_pouches_per_roll: "",
    uom: "Units" // Set default value
  });

  useEffect(() => {
    const calculateConversion = () => {
      const roll = parseFloat(editFormData.roll) || 0;
      const weight = parseFloat(editFormData.wieght_in_kg_for_rolls) || 0;
      const pouchesPerKg = parseFloat(editFormData.pouches_per_kg) || 0;
      
      const conversion = roll * weight * pouchesPerKg;
      
      setEditFormData(prev => ({
        ...prev,
        conversion_to_pouches_per_roll: conversion > 0 ? Math.round(conversion) : ""
      }));
    };

    calculateConversion();
  }, [editFormData.roll, editFormData.wieght_in_kg_for_rolls, editFormData.pouches_per_kg]);

  // Column Definitions
  const columnWithDefs = [
    {
      headerName: "",
      field: "actions",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}>
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.data)}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    {
      headerName: "FG Category",
      field: "fg_category",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Roll",
      field: "roll",
      sortable: true,
      resizable: true,
      width: 100,
      valueFormatter: (params) => {
        return params.value ? params.value.toString() : '0';
      }
    },
    {
      headerName: "Weight (KG) Per Roll",
      field: "wieght_in_kg_for_rolls",
      sortable: true,
      resizable: true,
      width: 180,
      valueFormatter: (params) => {
        return params.value ? params.value.toString() : '0';
      }
    },
    {
      headerName: "Pouches per KG",
      field: "pouches_per_kg",
      sortable: true,
      resizable: true,
      width: 150,
      valueFormatter: (params) => {
        return params.value ? params.value.toString() : '0';
      }
    },
    {
      headerName: "Pouches per Roll",
      field: "conversion_to_pouches_per_roll",
      sortable: true,
      resizable: true,
      width: 220,
      valueFormatter: (params) => {
        return params.value ? params.value.toString() : '0';
      }
    },
    {
      headerName: "UOM",
      field: "uom",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    },
    {
      headerName: "Updated Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    }
  ];

  const resetFormData = () => {
    setEditFormData({ 
      fg_category: "",
      roll: "",
      wieght_in_kg_for_rolls: "",
      pouches_per_kg: "",
      conversion_to_pouches_per_roll: "",
      uom: "Units" // Reset to default
    });
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const onClickAddNewPmConversion = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Add New PM Conversion Metric");
    setOverlyBlock("show-m");
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  // Status Panel Configuration
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 100,
  };

  const getPmConversionMetricData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const response = await redirectURL.post("masters/getPmConversionMetricData", {});
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setTimeout(() => autoSizeAllColumns(), 100);
        } else {
          setBasicTitle("No PM Conversion Metric data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching PM Conversion Metric data:", error);
      setBasicTitle("Failed to fetch PM Conversion Metric data");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  
  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  // Close Alert
  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setSliderOpen(false);
    resetFormData();
  };

  // Close Slider
  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const handleInputChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // const handleAddPmConversion = async () => {
  //   setLoadshow("show-m");
  //   setOverlayBlock("show-m");
    
  //   const params = {
  //     fg_category: editFormData.fg_category,
  //     roll: parseInt(editFormData.roll) || 0,
  //     wieght_in_kg_for_rolls: parseFloat(editFormData.wieght_in_kg_for_rolls) || 0,
  //     pouches_per_kg: parseInt(editFormData.pouches_per_kg) || 0,
  //     conversion_to_pouches_per_roll: parseInt(editFormData.conversion_to_pouches_per_roll) || 0,
  //     uom: "Units" 
  //   };

  //   const mandatoryFields = ['fg_category', 'roll', 'wieght_in_kg_for_rolls', 'pouches_per_kg'];
  //   const validationErrors = mandatoryFields.filter(
  //     (key) => !params[key] || params[key].toString().trim() === "" || Number(params[key]) <= 0
  //   );

  //   if (validationErrors.length > 0) {
  //     setShow(true);
  //     setBasicType("info");
  //     setBasicTitle(`Please fill all mandatory fields`);
  //     setLoadshow("show-n");
  //     setOverlayBlock("show-n");
  //     return;
  //   }

  //   const numericFields = ['roll', 'wieght_in_kg_for_rolls', 'pouches_per_kg'];
  //   for (const field of numericFields) {
  //     if (params[field] <= 0) {
  //       setShow(true);
  //       setBasicType("info");
  //       setBasicTitle(`${field.replace(/_/g, ' ').toUpperCase()} must be a valid positive number`);
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //       return;
  //     }
  //   }

  //   try {
  //     const response = await redirectURL.post("masters/addPmConversionMetric", params);
      
  //     if (response.status === 200 && response.data.status === "success") {
  //       await getPmConversionMetricData();
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //       setShow(true);
  //       setBasicType("success");
  //       setBasicTitle("PM Conversion Metric Added Successfully");
  //       setSliderOpen(false);
  //       setOverlyBlock("show-n");
  //       resetFormData();
        
  //       // User Action Triggering
  //       const userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "New PM Conversion Metric Added",
  //         status: "Success",
  //         path: window.location.pathname
  //       };
  //       triggerUserAction(userData);
  //     } else {
  //       setLoadshow("show-n");
  //       setOverlayBlock("show-n");
  //       setShow(true);
  //       setBasicType("info");
  //       setBasicTitle(response.data.message || "Failed to add PM Conversion Metric");
        
  //       // User Action Triggering
  //       const userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "New PM Conversion Metric Added",
  //         status: "Failure",
  //         path: window.location.pathname
  //       };
  //       triggerUserAction(userData);
  //     }
  //   } catch (error) {
  //     const message = error.response?.data?.message || "An error occurred";
  //     setShow(true);
  //     setBasicType("info");
  //     setBasicTitle(message);
  //     setLoadshow("show-n");
  //     setOverlayBlock("show-n");
      
  //     // User Action Triggering
  //     const userData = {
  //       email: localStorage.getItem("email"),
  //       user_code: localStorage.getItem("user_code"),
  //       action: "New PM Conversion Metric Added",
  //       status: "Failure",
  //       path: window.location.pathname
  //     };
  //     triggerUserAction(userData);
  //   }
  // };


    const handleAddPmConversion = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");

    const params = {
      fg_category: editFormData.fg_category?.trim(),
      roll: Number(editFormData.roll),
      wieght_in_kg_for_rolls: Number(editFormData.wieght_in_kg_for_rolls),
      pouches_per_kg: Number(editFormData.pouches_per_kg),
      conversion_to_pouches_per_roll: Number(editFormData.conversion_to_pouches_per_roll),
      uom: "Units"
    };

    const showError = (message) => {
      setShow(true);
      setBasicType("info");
      setBasicTitle(message);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    };

    if (!params.fg_category) {
      return showError("FG Category is required");
    }

    if (!params.roll || params.roll <= 0) {
      return showError("Roll must be greater than 0");
    }

    if (!params.wieght_in_kg_for_rolls || params.wieght_in_kg_for_rolls <= 0) {
      return showError("Weight in KG for Rolls must be greater than 0");
    }

    if (!params.pouches_per_kg || params.pouches_per_kg <= 0) {
      return showError("Pouches per KG must be greater than 0");
    }

    if (!params.conversion_to_pouches_per_roll || params.conversion_to_pouches_per_roll <= 0) {
      return showError("Conversion to Pouches per Roll must be a valid positive number");
    }

    try {
      const response = await redirectURL.post(
        "masters/addPmConversionMetric",
        params
      );

      if (response.status === 200 && response.data.status === "success") {

        await getPmConversionMetricData();

        setShow(true);
        setBasicType("success");
        setBasicTitle("PM Conversion Metric Added Successfully");

        setSliderOpen(false);
        setOverlyBlock("show-n");
        resetFormData();

        triggerUserAction({
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New PM Conversion Metric Added",
          status: "Success",
          path: window.location.pathname
        });

      } else {
        showError(response.data.message || "Failed to add PM Conversion Metric");
      }

    } catch (error) {
      showError(
        error.response?.data?.message || "Something went wrong while adding PM Conversion Metric"
      );

      triggerUserAction({
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "New PM Conversion Metric Added",
        status: "Failure",
        path: window.location.pathname
      });
    }
  };

  // Delete PM Conversion Metric
  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      const response = await redirectURL.post("masters/deletePmConversionMetric", {
        id: selectedRow._id
      });
      
      if (response.data.status === "success") {
        await getPmConversionMetricData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("PM Conversion Metric Deleted Successfully");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM Conversion Metric Deleted",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete PM Conversion Metric");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM Conversion Metric Deleted",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete PM Conversion Metric");
      
      // User Action Triggering
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "PM Conversion Metric Deleted",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  // Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  };

  useEffect(() => {
    getPmConversionMetricData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>
              PM Conversion Metric Masters
            </h1>
          </div>
          
          {/* Add Button */}
          <div className="col-sm-12 mb-4" style={{ display: "flex", justifyContent: "flex-end" }}>
            <button 
              onClick={onClickAddNewPmConversion}
              style={{
                ...addButtonStyle,
                backgroundColor: "#93385D",
                color: "#fff",
                border: "2px solid #93385D",
              }}
            >
              <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
              {" Add New"}
            </button>
          </div>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{ suppressHorizontalScroll: false }}
                onGridReady={onGridReady}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p className="m-0p" style={{ cursor: "pointer" }} onClick={onClickingSliderCloseIcon}>
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {/* Add Form */}
        {sliderType === 1 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "100%", 
            overflow: "hidden" 
          }}>
            <form style={{ 
              flexGrow: 1, 
              overflowY: "auto", 
              padding: "20px",
              height: "100%"
            }}>
              <div style={{ paddingBottom: "20px" }}>
                {/* FG Category */}
                <div className="form-group">
                  <label htmlFor="fg_category" style={labelStyle}>
                    FG Category <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="fg_category"
                    value={editFormData.fg_category}
                    onChange={(e) => handleInputChange('fg_category', e.target.value)}
                    placeholder="Enter FG Category"
                    style={inputStyle}
                    required
                    autoComplete="off"
                  />
                </div>

                {/* Roll */}
                <div className="form-group">
                  <label htmlFor="roll" style={labelStyle}>
                    Roll <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="roll"
                    value={editFormData.roll}
                    onChange={(e) => handleInputChange('roll', e.target.value)}
                    placeholder="Enter Roll"
                    style={inputStyle}
                    min="1"
                    required
                    autoComplete="off"
                  />
                </div>

                {/* Weight in KG for Rolls */}
                <div className="form-group">
                  <label htmlFor="wieght_in_kg_for_rolls" style={labelStyle}>
                    Weight in KG for Rolls <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="wieght_in_kg_for_rolls"
                    value={editFormData.wieght_in_kg_for_rolls}
                    onChange={(e) => handleInputChange('wieght_in_kg_for_rolls', e.target.value)}
                    placeholder="Enter Weight in KG for Rolls"
                    style={inputStyle}
                    min="0.01"
                    step="0.01"
                    required
                    autoComplete="off"
                  />
                </div>

                {/* Pouches per KG */}
                <div className="form-group">
                  <label htmlFor="pouches_per_kg" style={labelStyle}>
                    Pouches per KG <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="pouches_per_kg"
                    value={editFormData.pouches_per_kg}
                    onChange={(e) => handleInputChange('pouches_per_kg', e.target.value)}
                    placeholder="Enter Pouches per KG"
                    style={inputStyle}
                    min="1"
                    required
                    autoComplete="off"
                  />
                </div>

                {/* Conversion to Pouches per Roll (Read-only) */}
                <div className="form-group">
                  <label htmlFor="conversion_to_pouches_per_roll" style={labelStyle}>
                    Conversion to Pouches per Roll
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="conversion_to_pouches_per_roll"
                    value={editFormData.conversion_to_pouches_per_roll}
                    readOnly
                    style={{...inputStyle, backgroundColor: "#f8f9fa", color: "#6c757d"}}
                    placeholder="Auto-calculated"
                  />
                  {/* <small style={{ color: "#6c757d", fontSize: "0.8rem" }}>
                    Formula: Roll × Weight in KG for Rolls × Pouches per KG
                  </small> */}
                </div>

                {/* UOM (Hidden but included in data) */}
                <input
                  type="hidden"
                  value="Units"
                />

                {/* Submit Button */}
                <div style={submitButtonContainerStyle}>
                  <button
                    type="button"
                    onClick={handleAddPmConversion}
                    style={submitButtonStyle}
                  >
                    ADD
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={deletePopupStyle}
        >
          <div className="inventory-delete-popup">
            <p style={deletePopupTextStyle}>
              {`Are you sure you want to delete ${selectedRow ? selectedRow.fg_category : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-danger" onClick={onClickingPopupDeleteBtn}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={onClickDeletePopupCancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "5px"
};

const labelStyle = {
  fontSize: "0.9rem",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "5px",
  display: "block"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "0.9rem"
};

const submitButtonContainerStyle = {
  textAlign: "right",
  marginTop: "20px",
  paddingTop: "10px",
  borderTop: "1px solid #eee"
};

const submitButtonStyle = {
  backgroundColor: "#93385D",
  color: "#fff",
  padding: "10px 30px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold"
};

const deletePopupStyle = {
  position: "fixed",
  top: "40%",
  left: "40%",
  zIndex: "1003",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  padding: "20px",
  borderRadius: "10px",
};

const deletePopupTextStyle = {
  color: "grey",
  fontSize: "19px",
  textAlign: "center",
  fontWeight: "bold",
  marginBottom: "20px",
};

export default PmConversionMetricMaster;